import {
	Store,
} from '../utils/store';

const {
	pageType,
	postType,
	postsPerPage,
	maxNumPages,
	category,
	taxonomy,
	term,
	tagID,
	author,
} = window.infiniteScrollParams;

/**
 * The definitions for class attributes, along with setters and getters.
 * These have been placed in a parent class because the InfiniteScroll class was getting too large.
 */
export class InfiniteScrollBase {

	// Stores.
	_articles = new Store();
	_sections = new Store();
	_loadMoreSectionQueue = [];
	_postIDs = [];

	// Containers, Elements.
	_mainContentCtn;
	_spinnerCtn;
	_noMoreCtn;
	_contentSectionCtns; // Each section of content.
	_latestContentSectionCtn; // The most recently added content section container.
	_latestContentSectionArticleCtns;// The article containers within the most recently added content section container.
	_contentSectionsInViewport;

	// Indexing to note what sections the app is up to and what section is in view.
	_currentSectionIndex = 0; // The current index of the section on the page.
	_currentSectionViewIndex = 0; // The current index of the section in the viewport.

	// WordPress query vars, interpreted on the server.
	_pageType = pageType;
	_postType = postType;
	_postsPerPage = postsPerPage;
	_maxNumPages = parseInt( maxNumPages );
	_paged = 1; // Different to the current section.
	_include = []; // Stores post ids to include.
	_exclude = []; // Stores post ids to exclude.
	_search;
	_offset;
	_category = parseInt( category ) > 0 ? [ parseInt( category ) ] : [];
	_taxonomy = taxonomy;
	_term = term;
	_tagID =  parseInt( tagID ) > 0 ? parseInt( tagID ) : 0;
	_author = parseInt( author ) > 0 ? parseInt( author ) : 0;

	// Info.
	_currentArticleID;
	_previousArticleID;

	// Flags.
	_fetching = false;
	_noMorePages = false
	_consecutiveFailedRequests = 0;// Used to determine the number of failed attempts.
	_end = false; // End of app.

	/**
	 * Initialize the app.
	 *
	 * @param {string} mainContentCtnId
	 * @param {string} spinnerCtnId
	 * @param {string} noMoreCtnId
	 */
	constructor( mainContentCtnId, spinnerCtnId, noMoreCtnId ) {
		this.mainContentCtn = $( `#${ mainContentCtnId }` );
		this.spinnerCtn = $( `#${ spinnerCtnId }` );
		this.noMoreCtn = $( `#${ noMoreCtnId }` );
	}

	/** ------------------------------------------------------------------------------------------
	 * Misc.
	 * ------------------------------------------------------------------------------------------ */

	/**
	 * Hide the pagination if the element exists.
	 */
	hidePagination() {
		const paginationEl = $( '.pagination-main' );

		if ( paginationEl.length ) {
			paginationEl.hide();
		}
	}

	/** ------------------------------------------------------------------------------------------
	 * Setters.
	 * ------------------------------------------------------------------------------------------ */

	// Stores.
	set loadMoreSectionQueue( value ) {
		this._loadMoreSectionQueue.push( value );
	}

	set postIDs( value ) {
		this._postIDs.push( value );
	}

	// Containers, Elements.

	set mainContentCtn( value ) {
		this._mainContentCtn = value;
	}

	set spinnerCtn( value ) {
		this._spinnerCtn = value;
	}

	set noMoreCtn( value ) {
		this._noMoreCtn = value;
	}

	set contentSectionCtns( value ) {
		this._contentSectionCtns = value;
	}

	set latestContentSectionCtn( value ) {
		this._latestContentSectionCtn = value;
	}

	set latestContentSectionArticleCtns( value ) {
		this._latestContentSectionArticleCtns = value;
	}

	set contentSectionsInViewport( value ) {
		this._contentSectionsInViewport = value;
	}

	// Indexing.

	set currentSectionIndex( value ) {
		this._currentSectionIndex = value;
	}

	set currentSectionViewIndex( value ) {
		this._currentSectionViewIndex = value;
	}

	// WordPress query vars, interpreted on the server.

	set pageType( value ) {
		this._pageType = value;
	}

	set postType( value ) {
		this._postType = value;
	}

	set maxNumPages( value ) {
		this._maxNumPages = parseInt( value );
	}

	set paged( value ) {
		this._paged = value;
	}

	set include( value ) {
		this._include.push( value );
	}

	set exclude( value ) {
		value = parseInt( value );
		if ( ! this.exclude.includes( value ) ) {
			this._exclude.push( parseInt( value ) );
		}
	}

	set search( value ) {
		this._search = value;
	}

	set offset( value ) {
		this._offset = value;
	}

	set category( value ) {
		value = parseInt( value );
		if ( ! this.category.includes( value ) ) {
			this._category.push( parseInt( value ) );
		}
	}

	set taxonomy( value ) {
		this._taxonomy = value;
	}

	set term( value ) {
		this._term = value;
	}

	set tagID( value ) {
		this._tagID = value;
	}

	set author( value ) {
		value = parseInt( value );
		this._author = value;
	}

	// Info.
	set previousArticleID( value ) {
		this._previousArticleID = value;
	}

	set currentArticleID( value ) {
		this._currentArticleID = value;
	}

	// Flags.

	set fetching( value ) {
		this._fetching = value;
	}

	set noMorePages( value ) {
		this._noMorePages = value;
	}

	set end( value ) {
		this._end = value;
	}

	set consecutiveFailedRequests( value ) {
		this._consecutiveFailedRequests = value;
	}

	/** ------------------------------------------------------------------------------------------
	 * Getters.
	 * ------------------------------------------------------------------------------------------ */

	// Stores.
	get articles() {
		return this._articles;
	}

	get sections() {
		return this._sections;
	}

	get loadMoreSectionQueue() {
		return this._loadMoreSectionQueue;
	}

	get postIDs() {
		return this._postIDs;
	}

	// Containers, Elements.

	get mainContentCtn() {
		return this._mainContentCtn;
	}

	get spinnerCtn() {
		return this._spinnerCtn;
	}

	get noMoreCtn() {
		return this._noMoreCtn;
	}

	get contentSectionCtns() {
		return this.mainContentCtn.find( '.content-section' );
	}

	get latestContentSectionCtn() {
		return this._latestContentSectionCtn;
	}

	get latestContentSectionArticleCtns() {
		return this._latestContentSectionArticleCtns;
	}

	get contentSectionsInViewport() {
		return this._contentSectionsInViewport;
	}

	// Indexing

	get currentSectionIndex() {
		return this._currentSectionIndex;
	}

	get currentSectionViewIndex() {
		return this._currentSectionViewIndex;
	}

	// WordPress query vars, interpreted on the server.

	get pageType() {
		return this._pageType;
	}

	get postType() {
		return this._postType;
	}

	get postsPerPage() {
		return this._postsPerPage;
	}

	get maxNumPages() {
		return this._maxNumPages;
	}

	get paged() {
		return this._paged;
	}

	get include() {
		return this._include;
	}

	get exclude() {
		return this._exclude;
	}

	get search() {
		return this._search;
	}

	get offset() {
		return this._offset;
	}

	get category() {
		return this._category;
	}

	get taxonomy() {
		return this._taxonomy;
	}

	get term() {
		return this._term;
	}

	get tagID() {
		return this._tagID;
	}

	get author() {
		return this._author;
	}

	// Info.

	get previousArticleID() {
		return this._previousArticleID;
	}

	get currentArticleID() {
		return this._currentArticleID;
	}

	// Flags.
	get fetching() {
		return this._fetching;
	}

	get noMorePages() {
		this._noMorePages;
	}

	get end() {
		return this._end;
	}

	get consecutiveFailedRequests() {
		return this._consecutiveFailedRequests;
	}

}
